<template>
  <div class="typeTabs clear">
    <div class="TabsContent" :style="{background:bacColor}" ref="TabsContent">
      <ul :style="{width:ulWidth}" class="clear">
        <li v-for="(item,index) in cardata.data"
            ref="lis"
            :class="acNum==index?'AcLi':''"
            @click="clickFn(item,index)">
          {{item.name}}
        </li>
      </ul>
    </div>
    <div class="menusBut" :class="menusState?'menusAc':''" @click="menusFn" ref="menusBut">
      <i class="iconfont  icon-caidan"></i>
    </div>
    <div class="allTabs" :class="menusState?'allTabsShow':''">
      <h2>全部服务</h2>
      <div class="allTabsContent clear">
        <span class="allTabsContentList" :class="itme.icon?'allTabsContentListIcon':''"
              v-for="(itme,index) in cardata.data"
              @click="clickFn(itme,index)">
            <div class="Icon" v-if="itme.icon">
              <img :src="itme.icon">
            </div>
           <p class="text">{{itme.name}}</p>
        </span>
      </div>
    </div>
    <div class="modal" :class="menusState?'modalShow':''" @click="menusFn"></div>
  </div>
</template>

<script>
  import Toucth from '../../../../assets/js/method'
  import XkModalMod from '../../modalMod/src/modalMod'

  export default {
    components: {XkModalMod},
    name: 'xk-type-tabs',
    props: ['cardata', 'bacColor', 'defaultmum'],
    computed: {},
    data () {
      return {
        ulWidth: '100%',
        acNum: 0,
        menusState: false
      }
    },
    watch: {
      cardata: function (val) {
        let that = this
        if (val) {
          that.ulWidthFn()
        }
      }
    },
    methods: {
      menusFn: function (val) { // 菜单事件
        this.menusState = !this.menusState
      },
      // allTabsFn: function (index) {
      //   this.acNum = index
      //   this.menusState = false
      //   let li = this.$refs.lis[index]
      //   this.$refs.TabsContent.scrollLeft = li.offsetLeft - li.offsetWidth
      // },
      clickFn: function (obj, index) {
        this.acNum = index
        let li = this.$refs.lis[index]
        this.$refs.TabsContent.scrollLeft = li.offsetLeft - li.offsetWidth
        console.log(obj)
        this.menusState = false
        this.$emit('click', {index: index, data: obj, businessId: obj.id})
      },
      ulWidthFn: function () {
        let that = this
        let lis = that.$refs.lis
        let liW = null
        that.ulWidth = 0
        if (lis && lis.length > 0) {
          for (let i = 0; i < lis.length; i++) {
            let liP = Toucth.gainStyle(lis[i], 'padding')
            liP = liP.replace('0px ', '')
            liP = liP.replace('px', '')
            liP = Number(liP) * 2
            liW = Number(Toucth.gainStyle(lis[i], 'width', 'px'))
            that.ulWidth += liW
            that.ulWidth += liP
          }
          that.ulWidth += 'px'
        }
      }
    },
    mounted: function () {
      let that = this
      if (that.$props.cardata) {
        that.ulWidthFn()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .typeTabs {
    width: 100%;
    height: 100%;
    position: relative;
    min-height: 3.2rem;
    .TabsContent {
      width: calc(~'100% - 3.6rem');
      float: left;
      height: 100%;
      overflow-x: auto;
      z-index: 200;
      ul {
        /*width: auto;*/
        height: 100%;
        display: flex;
        justify-content: space-between;
        li {
          height: 100%;
          float: left;
          padding: 0 1.6rem;
          transition: 0.3s all;
          line-height: 3.2;
          color: #666666;
          min-width: 6rem;
          text-align: center;
        }
        .AcLi {
          height: 100%;
          background-color: #fff;
          color: #f06553;
          text-align: center;
        }
      }
    }
    .menusBut {
      float: right;
      text-align: center;
      width: 3.6rem;
      height: 100%;
      position: relative;
      z-index: 100;
      min-height: 3.2rem;
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .menusAc {
      z-index: 80;
      background-color: #fff;
    }
    .allTabs {
      opacity: 0;
      z-index: -100;
      box-sizing: border-box;
      position: absolute;
      text-align: center;
      top: 3rem;
      width: 100%;
      left: 0;
      transform-origin: 0 0;
      transform: scale(1, 0);
      transition: 0.3s all;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      border: 1px solid rgba(0, 0, 0, 0.04);
      border-top: none;
      h2 {
        font-size: 1.3rem;
        color: #333;
        border-bottom: 1px solid #eee;
      }
      .allTabsContent {
        max-height: 14rem;
        overflow-y: scroll;
        .allTabsContentList {
          box-sizing: border-box;
          border-bottom: 1px solid rgba(0, 0, 0, 0.04);
          border-right: 1px solid rgba(0, 0, 0, 0.04);
          width: 33.3333%;
          float: left;
          .text {
            color: #666;
          }
        }
        .allTabsContentListIcon {
          height: 7rem;
          .Icon {
            width: 100%;
            text-align: center;
            margin-top: 1rem;
            img {
              width: 50%;
            }
          }
          p {
            line-height: normal;
            margin-top: -1rem;
            margin-bottom: 0.5rem;
          }
        }
        .allTabsContentList:nth-child(3n) {
          border-right: none;
        }
      }
    }
    .allTabsShow {
      opacity: 1;
      z-index: 79;
      transform: scale(1, 1);
    }
    .modal {
      position: fixed;
      width: 100%;
      height: 100%;
      opacity: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: -100;
    }
    .modalShow {
      z-index: 50;
    }
  }
</style>



// WEBPACK FOOTER //
// typeTabs.vue?630ffbb3